// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Me_v5lqdrDJdyklUZE1z{display:flex;flex-direction:column;justify-content:center;background-repeat:repeat}._56KuRUFChFLnCzYQu04{font-size:toEm(16px)}", "",{"version":3,"sources":["webpack://./src/Pages/CosmeticDetail/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,sBAAA,CACA,wBAAA,CAGF,sBACE,oBAAA","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-repeat: repeat;\n}\n\n.tooltipProvider {\n  font-size: toEm(16px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "Me_v5lqdrDJdyklUZE1z",
	"tooltipProvider": "_56KuRUFChFLnCzYQu04"
};
export default ___CSS_LOADER_EXPORT___;
